import functionListApi from "@/api/functionList/functionListApi";

export default {
	name: 'function-list',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			billHome: { ftInvoiceResp: {} }
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {
		// 若網址為 /Billing#/xxx => 轉為 /Billing/#/xxx
		/*
		const hash = window.location.hash;
		const href = window.location.href;
		const index = href.indexOf(hash);
		if(href.charAt(index - 1) != '/') {
			window.location.href = href.substring(0, index) + '/' + href.substring(index);
		} else {
			this.initPage();
		}
		*/
		this.redirectToEcHome();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async initPage() {
			this.billHome = await functionListApi.getBillDetails();
		},
		redirectToEcHome() {
			window.location.href = '/ecare/#/'
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/functionList/functionList.js